var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4284 6.06134V5.76039C19.4284 4.37693 18.3028 3.25136 16.9193 3.25136H2.50903C1.12552 3.2514 0 4.37693 0 5.76039V6.06134H19.4284Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4782 14.1322C11.4782 12.8308 11.8968 11.5937 12.6696 10.5742H0V14.0741C0 15.4576 1.12552 16.5832 2.50903 16.5832H12.0078C11.6611 15.8237 11.4782 14.9921 11.4782 14.1322ZM9.7142 13.3718H7.54875V12.0827H9.7142V13.3718ZM2.88999 12.0827H6.25969V13.3718H2.88999V12.0827Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0078 9.28522C14.9909 8.59742 16.1587 8.22685 17.3836 8.22685C18.0926 8.22685 18.7823 8.35133 19.4284 8.58925V7.35046H0V9.28522H14.0078Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 14.1322C22 11.5827 19.9331 9.5159 17.3836 9.5159C14.8341 9.5159 12.7672 11.5827 12.7672 14.1322C12.7672 16.6818 14.834 18.7486 17.3836 18.7486C19.9331 18.7486 22 16.6818 22 14.1322ZM18.0059 16.5984V17.123H17.3613V17.1231V17.123H16.7168V16.6023C16.3271 16.4704 16.0083 16.2382 15.6969 16.0105L16.4579 14.97C16.8762 15.2759 17.0903 15.423 17.3836 15.423C17.5495 15.423 17.6837 15.3441 17.7341 15.217C17.795 15.0632 17.7089 14.9215 17.5036 14.8379C17.5036 14.8379 16.5823 14.5306 16.1564 14.0963C15.799 13.732 15.6853 13.2186 15.7991 12.7301C15.9136 12.2384 16.2457 11.8538 16.7168 11.6618V11.1414H18.0059V11.6402C18.3333 11.7312 18.6104 11.8655 18.7697 11.952L18.1547 13.0849C17.7469 12.8636 17.3718 12.7971 17.2258 12.8471C17.0841 12.8954 17.0626 12.9878 17.0545 13.0226C17.043 13.0719 17.0368 13.1475 17.1156 13.2354C17.1915 13.3199 17.9896 13.644 17.9896 13.644C18.8508 13.9946 19.2561 14.875 18.9324 15.6918C18.7643 16.1164 18.4259 16.438 18.0059 16.5984Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementsIcon);
export default __webpack_public_path__ + "static/media/announcements-icon.eb350be3b836fbdae1d3569ddedd4f9e.svg";
export { ForwardRef as ReactComponent };